class OpsEndpointPathsUtility {
  public static postAppointmentReservationUrl = (
    leadId?: string | null,
    customerId?: string | null,
    centerId?: string | null,
    serviceId?: string | null,
    slotId?: string | null
  ) =>
    `Legacy/V1/ops/contacts/${leadId}/customers/${customerId}/centers/${centerId}/services/${serviceId}/slots/${slotId}`;

  public static aspirePutCustomerUrl = (leadId: string, customerId: string) =>
    `Legacy/V0/Ops/Contacts/${leadId}/Customers/${customerId}`;

  public static aspirePostCustomerUrl = (leadId: string) => `Legacy/V0/Ops/Contacts/${leadId}/Customers`;

  public static postAppointmentUrl = (
    contactId: string | null,
    customerId?: string,
    centerId?: string | null,
    appointmentId?: string | null,
    slotId?: string | null
  ) => {
    const appointmentIdValue = appointmentId ? "/" + appointmentId : "";
    return `Legacy/V1/ops/contacts/${contactId}/customers/${customerId}/centers/${centerId}/appointments${appointmentIdValue}/slots/${slotId}`;
  };

  public static getCalendarUrl = (contactId: string, customerId: string | null, centerId: string) =>
    `Legacy/V1/ops/contacts/${contactId}/customers/${customerId}/centers/${centerId}/calendars`;
}

export default OpsEndpointPathsUtility;
